var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.50053 7.78905C9.64343 7.78905 11.3951 6.03742 11.3951 3.89452C11.3951 1.75161 9.64375 -1.52588e-05 7.50053 -1.52588e-05C5.3573 -1.52588e-05 3.60632 1.75161 3.60632 3.89452C3.60632 6.03742 5.35795 7.78905 7.50085 7.78905H7.50053ZM14.1841 10.9014C14.081 10.6494 13.9499 10.4098 13.7932 10.1872C13.0109 9.03059 11.8033 8.26528 10.4429 8.07811C10.2727 8.06118 10.0858 8.09536 9.94975 8.19725C9.23523 8.7246 8.38497 8.99673 7.50053 8.99673C6.61609 8.99673 5.76583 8.7246 5.05163 8.19725C4.91557 8.09536 4.72839 8.04426 4.55847 8.07811C3.88228 8.17155 3.23376 8.40797 2.65608 8.77163C2.0784 9.13529 1.58482 9.61784 1.20821 10.1872C1.05488 10.4119 0.923837 10.6511 0.816933 10.9014C0.765826 11.0032 0.783078 11.1227 0.83386 11.2246C0.969927 11.4626 1.13985 11.7008 1.29284 11.9049C1.52617 12.2229 1.78812 12.5188 2.0754 12.789C2.31368 13.0273 2.58549 13.248 2.85762 13.4694C4.20137 14.473 5.81693 15 7.4836 15C9.15027 15 10.7658 14.4726 12.1093 13.4694C12.3855 13.261 12.647 13.0337 12.8918 12.789C13.1639 12.5169 13.4361 12.2278 13.674 11.9049C13.8443 11.6836 13.9973 11.4626 14.133 11.2246C14.2183 11.1224 14.2352 11.0032 14.1841 10.9014Z",
    fill: "#D0D4E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.a12e5de079c02d0a034469b7e81b47b6.svg";
export { ForwardRef as ReactComponent };